import { forwardRef } from 'react';
import { Button as ThemeButton, ButtonProps } from 'theme-ui';
import { desaturate, lighten } from '@theme-ui/color';

type ButtonSizes = 'small'|'normal'|'large'|'huge';

export interface CustomButtonProps extends ButtonProps {
  fullWidth?: boolean;
  size?: ButtonSizes
};

const Button = forwardRef<HTMLButtonElement, CustomButtonProps>(({
  sx,
  disabled,
  variant = 'primary',
  fullWidth = false,
  size = 'normal',
  ...props
}: CustomButtonProps, ref) => {
  const disabledColor = t => disabled ? lighten(desaturate(variant, 0.6)(t), 0.4)(t) : undefined;

  return (
    <ThemeButton
      ref={ref}
      {...props}
      disabled={disabled}
      variant={variant}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 'max-content',
        fontSize: size === 'small' ? '0.8em' : size === 'large' ? '1.6em' : size === 'huge' ? '2.0em' : undefined,
        px: size === 'small' ? 2 : size === 'large' ? 3 : size === 'huge' ? 4 : undefined,
        py: size === 'small' ? 1 : size === 'large' ? 2 : size === 'huge' ? 3 : undefined,
        bg: disabledColor,
        ':hover': {
          bg: disabledColor
        },
        cursor: disabled ? 'auto' : undefined,
        width: fullWidth ? '100%' : undefined,
        ...sx
      }}
    />
  );
});

export default Button;
